import { useEffect, useState } from 'react';
import orgService from '../services/orgService';
import { useUser } from '../features/authentication';

export const useEasyLink = () => {
  const { user } = useUser();
  const orgId = user?.lastSelectedAccount;
  const [easyLinkPrefix, setEasyLinkPrefix] = useState('');

  useEffect(() => {
    if (user && orgId) {
      orgService
        .getEasyLink(orgId)
        .then(res => setEasyLinkPrefix((res as { prefix: string }).prefix))
        .catch(err => console.error(err));
    }
  }, [user, orgId]);

  return easyLinkPrefix;
};
